module.exports = "<h5>Auto Patrocinio</h5>"